if (!customElements.get('mmc-incoming')) {
  customElements.define('mmc-incoming', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-incoming-config]').textContent);
      this.selected = this.config.selected;
      this.change = () => this.update(document.getElementById(this.dataset.form)?.querySelector('[name="id"]')?.value || this.selected);
      document.addEventListener('change', this.change);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const id = String(event.data?.variant?.id || '');
          if (this.config.variants.some(v => v.id === id)) this.update(id);
        });
      }
      this.update(this.selected);
      this.timer = setInterval(() => this.update(this.selected), 60000);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      clearInterval(this.timer);
      document.removeEventListener('change', this.change);
    }
    update(id) {
      this.selected = String(id);
      const state = this.config.variants.find(v => v.id === this.selected)?.arrival;
      const expiry = Date.parse(state?.valid_until || '');
      this.hidden = state?.status !== 'ANNOUNCED' || !Number.isFinite(expiry) || expiry <= Date.now() || !/^\d{4}-\d{2}-\d{2}$/.test(state?.supplier_arrival_date || '');
      if (!this.hidden) {
        const [y,m,d] = state.supplier_arrival_date.split('-');
        this.querySelector('[data-incoming-date]').textContent = this.config.template.replace('__DATE__',`${d}/${m}/${y}`);
      }
    }
  });
}
